export default __webpack_public_path__ + "static/IMG_9256-94e4d5c6c83ac73baafeacff781147c9.jpeg";